/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as o from "react";
class s extends o.Component {
  /**
   * @hidden
   */
  componentDidUpdate(e) {
    !e.selected && this.props.selected && this.elementToFocus.focus();
  }
}
export {
  s as FocusableUponSelection
};
